export default "__VITE_ASSET__C6JSf2cR__"